import { useContext } from 'react';
import BrowserHistoryContext from '../contexts/BrowserHistory/BrowserHistoryContext';

export default function useLandingProduct() {
    const { state } = useContext(BrowserHistoryContext);

    return [state.model_id];
}
